import React, { useEffect, useRef } from "react";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

/**
 * @param {{ users: RdmUser[], children: React.ReactNode }} props
 */
export function TippyRelatedUsers({ users, children }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    let content = "Nenhum usuário relacionado";
    if (users && users.length > 0) {
      const names = users
        .map((u) => u.userData?.username || "")
        .filter(Boolean);
      if (names.length <= 3) {
        content = names.join(", ");
      } else {
        content = `${names.slice(0, 3).join(", ")} e mais ${
          names.length - 3
        } outros...`;
      }
    }
    const instance = tippy(ref.current, {
      content,
      placement: "top",
      animation: "shift-away",
      theme: "light-border",
      delay: [100, 0],
    });
    return () => {
      instance.destroy();
    };
  }, [users]);

  return (
    <span ref={ref} style={{ cursor: "pointer", display: "inline-block" }}>
      {children}
    </span>
  );
}
